import InitLocale from "./components/InitLocale";

/**
 * This page is used to initialize the locale, local storage and set a device id cookie.
 * It the redirects to launcher route with the correct locale.
 * This ensures we have the correct config and locale before rendering the launcher.
 * The launcher does not perform any authentication checks so we avoid making non cacheable requests until the launcher button is clicked or the SDK open() method is called.
 */
export default function RootPage({
  params,
}: {
  params: { tenantId: string; messengerId: string; hostConfig: string };
}) {
  return <InitLocale params={params} />;
}
